export default "__VITE_ASSET__8FQqMJHK__"